export default "__VITE_ASSET__492af4ce__"